import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/LoginView.vue'),
      meta: { requiresGuest: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/auth/RegisterView.vue'),
      meta: { requiresGuest: true }
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/projects/:id?',
      name: 'projects',
      component: () => import('@/views/ProjectView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/testing/message-flow',
      name: 'message-flow-test',
      component: () => import('@/views/testing/MessageFlowTestPage.vue'),
      meta: { 
        requiresAuth: true,
        title: 'Message Flow Testing'
      }
    },
    {
      path: '/testing/notifications',
      name: 'notification-debug',
      component: () => import('@/views/testing/NotificationDebugView.vue'),
      meta: { 
        requiresAuth: true,
        title: 'Notification Debug Center'
      }
    },
    // Catch-all route
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/NotFoundView.vue')
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  
  // Initialize auth if not already done
  if (!authStore.isAuthenticated && !authStore.isLoading) {
    await authStore.initializeAuth()
  }
  
  // Check authentication requirements
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router